import { motion } from 'framer-motion'
import React from 'react'

import ImageByWidthDevice from '@/components/ImageByWidthDevice'
import { introLeftVariants, introRightVariants } from '@/config/const'
import { ImageResponsive } from '@/types/common'
import clsxm from '@/utils/clsxm'

interface BusinessOpportunitiesCardProps {
  title: string
  message: string
  isLeft?: boolean
  icon: ImageResponsive
  background: ImageResponsive
}

const BusinessOpportunitiesCard: React.FC<BusinessOpportunitiesCardProps> = ({
  title,
  message,
  isLeft,
  icon,
  background,
}) => {
  return (
    <motion.div
      className='group relative h-[345px] w-full overflow-hidden rounded-lg'
      initial='hide'
      whileInView='show'
      viewport={{ once: true }}
      variants={isLeft ? introLeftVariants : introRightVariants}
    >
      <div className='absolute inset-0 h-full rounded-lg'>
        <div className='absolute inset-0 bg-black/40 opacity-100 transition-all duration-300 lg:opacity-50 lg:group-hover:opacity-100' />

        <ImageByWidthDevice
          images={background}
          alt='card background'
          className='h-full rounded-lg object-cover object-center'
        />
      </div>

      <div className='absolute inset-0 z-20' />

      <div className='relative z-10 hidden pl-4 pt-5 lg:block'>
        <div className='flex h-20 w-20 items-center justify-center rounded-full bg-black/[0.15]'>
          {/*<span className={clsxm('text-[38px] text-white', icon)} />*/}
          <ImageByWidthDevice
            images={icon}
            alt='icon'
            className='h-[38px] w-[38px]'
          />
        </div>
      </div>

      <div
        className={clsxm(
          'absolute bottom-0 left-0 flex h-fit max-h-full w-full flex-col gap-4.5 overflow-hidden rounded-lg p-4 shadow-business-card transition-all duration-500 lg:-bottom-14 lg:left-0 lg:max-h-[144px]',
          'lg:group-hover:bottom-0 lg:group-hover:max-h-full'
        )}
      >
        <p className='text-3.5xl font-bold leading-8 text-yellow transition-all duration-300'>{title}</p>
        <div className='w-20 border border-white transition-all duration-700 lg:w-3 lg:group-hover:w-20' />
        <div
          className='description h-full max-h-60 break-words text-base leading-normal tracking-[-0.084px] text-white transition-all duration-300 lg:line-clamp-3 lg:group-hover:line-clamp-none'
          dangerouslySetInnerHTML={{ __html: message }}
        />
      </div>
    </motion.div>
  )
}

export default BusinessOpportunitiesCard
